import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ModalService } from '@shared/modal/modal.service';
import { catchError, tap } from 'rxjs';

@Injectable()
export class ConnectWithOurTeamService {
    private readonly fb = inject(FormBuilder);
    private readonly modalService = inject(ModalService);
    private readonly http = inject(HttpClient);

    public form = this.fb.group({
        name: ['', [Validators.required, Validators.maxLength(30)]],
        surname: ['', [Validators.maxLength(30)]],
        code: ['', [Validators.required]],
        phone: ['', [Validators.required]],
        email: ['', [Validators.required, Validators.email]],
        shortMessage: ['', [Validators.required, Validators.maxLength(256)]],
    });

    public sendContactForm(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }
        this.modalService.open();

        const { name, surname, code, phone, email, shortMessage } = this.form.value;
        const fullName = [name, surname]
            .map((value) => typeof value === 'string' && value.trim())
            .filter(Boolean)
            .join(' ');

        this.http
            .post('/send-email', {
                main: [
                    { field: 'Name', value: fullName },
                    { field: 'Email', value: email },
                    { field: 'Phone', value: `${code}${phone}` },
                    { field: 'Message', value: shortMessage },
                ],
            })
            .pipe(
                tap(() => {
                    this.resetForm();
                    this.modalService.changeToSuccess();
                }),
                catchError(() => {
                    this.resetForm();
                    this.modalService.changeToError();
                    return '';
                }),
            )
            .subscribe();
    }

    public resetForm(): void {
        this.form.reset();
    }
}
